/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
], function () {

	class Glass {
		constructor() {
		}
		getAPI() {
			return this;
		}

		showErrorMessage(message, title) {
			console.log(message, title);
		}

		showMessage(message) {
			console.log(message);
		}

		showToast(message, options) {
			console.log(message, options);
		}
		showSlideOut(options) {
			console.log('showSlideOut', options);

		}
		showContextMenu(options) {
			console.log('showContextMenu', options);
		}
		isDevInstall() {
			return false;
		}
		prepareGlassOptions(/*options*/) {
			// no op
		}
		openApplication(/*name, options*/) {
			throw new Error('openApplication not supported');
		}
		closeApplication(/*name, id, options*/) {
			throw new Error('closeApplication not supported');
		}

		getService(/*name*/) {
			throw new Error('getService not supported');
		}

		getCoreService(/*name*/) {
			throw new Error('getCoreService not supported');
		}

		getPlugin(/*name*/) {
			return null;
		}


	}
	return Glass;
});
